import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pg-masters-of-commerce',
  templateUrl: './pg-masters-of-commerce.component.html',
  styleUrls: ['./pg-masters-of-commerce.component.scss']
})
export class PgMastersOfCommerceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
